import React from "react";
import IntegrationAnimation from './IntegrationAnimation';
import ValidationAnimation from './ValidationAnimation';
import InstantAnimation from './InstantAnimation';

import './LandingIntro.css';

const LandingIntro = () => {
    return (
        <div className="landing-intro">
            <div className="content">
                {/* <div className="questions">
                    <span className="question">
                        <h5>Are you...</h5>
                        <p>a <span>Pre-Billing</span> or <span>Quality Assurance</span> specialist overwhelmed by the volume of reports coming in?</p>
                    </span>
                    <span className="question">
                        <h5>Or...</h5>
                        <p>an <span>EMS Director/Chief</span> or <span>Medical Director</span> that wants to better understand agency data and performance?</p>
                    </span>
                </div> */}
                
                {/* <h3>CADMUS can help with that.</h3> */}

                <div className="features">
                    <div className="card">
                        <IntegrationAnimation />
                        <h4> Easy <br/> Integration </h4>
                        <p>We connect our secure tool to your ePCR software for automatic report upload</p>
                    </div>
                    <div className="card">
                        <ValidationAnimation />
                        <h4> Comprehensive <br/> PCR Validation </h4>
                        {/* <p>Never miss another provider error with our finely tuned AI feedback</p>
                        <p>We analyze the narrative and report body simulataneously</p> */}
                        <p>Our AI-enabled algorithm includes the narrative in its total report analysis</p>
                        {/* <p>Narratives are examined during AI-enabled report analysis</p> */}
                    </div>
                    <div className="card">
                        <InstantAnimation />
                        <h4> Instant <br/> Feedback </h4>
                        {/* <p>Our automated process provides feedback on reports moments after completion</p> */}
                        <p>Medics receive PCR feedback moments after completion for immediate correction</p>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default LandingIntro;